import { render, staticRenderFns } from "./BeneficiariosListado.vue?vue&type=template&id=fbf998e2&scoped=true&"
import script from "./BeneficiariosListado.vue?vue&type=script&lang=js&"
export * from "./BeneficiariosListado.vue?vue&type=script&lang=js&"
import style0 from "./BeneficiariosListado.vue?vue&type=style&index=0&id=fbf998e2&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fbf998e2",
  null
  
)

export default component.exports